import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {field} from "../../stem-core/state/StoreField";
import {apiClient} from "../connection/BlinkApiClient";
import {UserProfile} from "./UserProfileStore";
import {Jurisdiction} from "./JurisdictionStore";
import {StemDate} from "../../stem-core/time/Date";

@globalStore
export class LegalEntity extends BaseStore("LegalEntity") {
    @field("UserProfile") owner: UserProfile;
    @field(Date) createdAt: StemDate;
    @field(String) name: string;
    @field(String) legalName: string;
    @field("Jurisdiction") jurisdiction: Jurisdiction;
    @field(String) legalEntityType: string;
    @field(Boolean) isNonProfit: boolean;
    @field(String) taxId: string;
    @field(String) streetAddress: string;
    @field(String) stateAddress: string;
    @field(String) cardStatementName: string;
    @field(String) bankAccountLastDigits: string;

    toString(): string {
        return this.name;
    }
}

export async function apiUpdateLegalEntity(data: any): Promise<any> {
    return apiClient.post("admin/legal_entities/update", data)
}
